import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { ErrorBox } from "@/components/ui/misc";
import { useAuth } from "@/lib/auth";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const MYMANAGER_URL = import.meta.env.DEV ? "http://localhost:3000" : "https://mymanager.com";

/**
 * Shown when the studio is opened outside MyManager. There is no sign-in here on
 * purpose: tokens are minted only by MyManager for its own signed-in staff and
 * partners, and the embed renews them; a bare tab has nobody to ask.
 */
export function SignInPage() {
  const { devLogin, token, hosted } = useAuth();
  const nav = useNavigate();
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  // A host token can still land after we got here (slow mint); go straight in.
  useEffect(() => {
    if (token && (hosted || import.meta.env.DEV)) nav("/app", { replace: true });
  }, [token, hosted, nav]);
  return (
    <div className="flex min-h-screen items-center justify-center p-6">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>MyManager Sales Studio</CardTitle>
          <CardDescription>
            {hosted
              ? "Waiting for MyManager to sign you in. If this doesn't clear, your MyManager account may not have Sales Studio enabled."
              : "Sales Studio runs inside MyManager only. Open it from the Sales Studio menu in MyManager, or from the Sales Studio tab of the partner portal."}
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-3">
          {err ? <ErrorBox message={err} /> : null}
          {!hosted ? (
            <a
              href={`${MYMANAGER_URL}/sales-studio`}
              className="inline-flex h-10 w-full items-center justify-center rounded-md bg-primary px-4 text-sm font-medium text-primary-foreground hover:bg-primary/90"
            >
              Open in MyManager
            </a>
          ) : null}
          {import.meta.env.DEV ? (
            <Button
              className="w-full"
              loading={busy}
              onClick={async () => {
                setBusy(true);
                setErr(null);
                try {
                  await devLogin();
                  nav("/app", { replace: true });
                } catch (e) {
                  setErr(e instanceof Error ? e.message : "sign in failed");
                } finally {
                  setBusy(false);
                }
              }}
            >
              Dev sign-in (local api)
            </Button>
          ) : null}
        </CardContent>
      </Card>
    </div>
  );
}
